'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CarouselAutoplayProvider: ()=>CarouselAutoplayProvider
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_namespaceObject = require("motion/react");
const external_react_namespaceObject = require("react");
const external_CarouselAutoplayContext_cjs_namespaceObject = require("./CarouselAutoplayContext.cjs");
function CarouselAutoplayProvider({ children }) {
    const [globalAutoplayPaused, setGlobalAutoplayPaused] = (0, external_react_namespaceObject.useState)(false);
    const carouselsRef = (0, external_react_namespaceObject.useRef)(new Map());
    const prefersReducedMotion = (0, react_namespaceObject.useReducedMotion)();
    const pauseAllCarousels = (0, external_react_namespaceObject.useCallback)(()=>{
        if (prefersReducedMotion) return;
        setGlobalAutoplayPaused(true);
        carouselsRef.current.forEach((controls)=>{
            controls.pause();
        });
    }, [
        prefersReducedMotion
    ]);
    const resumeAllCarousels = (0, external_react_namespaceObject.useCallback)(()=>{
        if (prefersReducedMotion) return;
        setGlobalAutoplayPaused(false);
        carouselsRef.current.forEach((controls)=>{
            controls.resume();
        });
    }, [
        prefersReducedMotion
    ]);
    const registerCarousel = (0, external_react_namespaceObject.useCallback)((id, controls)=>{
        carouselsRef.current.set(id, controls);
        if (globalAutoplayPaused) controls.pause();
    }, [
        globalAutoplayPaused
    ]);
    const unregisterCarousel = (0, external_react_namespaceObject.useCallback)((id)=>{
        carouselsRef.current.delete(id);
    }, []);
    const isCarouselRegistered = (0, external_react_namespaceObject.useCallback)((id)=>carouselsRef.current.has(id), []);
    const contextValue = {
        globalAutoplayPaused,
        pauseAllCarousels,
        resumeAllCarousels,
        registerCarousel,
        unregisterCarousel,
        isCarouselRegistered
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselAutoplayContext_cjs_namespaceObject.CarouselAutoplayContext.Provider, {
        value: contextValue,
        children: children
    });
}
exports.CarouselAutoplayProvider = __webpack_exports__.CarouselAutoplayProvider;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CarouselAutoplayProvider"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
